import React from "react";
import {UseFormReturn} from "react-hook-form";
import {withUseFormHook} from "@sinossi/mates-react-library";
import * as Yup from "yup";
import {t, Trans} from "@lingui/macro";
import {EditTitleAndDescriptionModalProps, EditTitleAndDescriptionModalState} from "./models";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Stack, Typography} from "@mui/material";
import {ZPlayFormField, ZPlayMultilineTextField} from "../../../../../../../commons/fields";
import ErrorIcon from "@mui/icons-material/Error";

const EditTitleAndDescriptionModalSchema = Yup.object().shape({

});


class EditTitleAndDescriptionModal extends React.Component<UseFormReturn & EditTitleAndDescriptionModalProps, EditTitleAndDescriptionModalState>{

    constructor(props: any) {

        super(props);

        this.state = {
            error: false,
        }
    }

    componentDidMount(){
        this.props.setValue("edit-modal-language", this.props.language.value);
        this.props.setValue("edit-modal-title", this.props.title);
        this.props.setValue("edit-modal-description", this.props.description);

    }

    private getValues = () => {
        let title = this.props.getValues("edit-modal-title")
        let description = this.props.getValues("edit-modal-description")

        if(title==="" || description===""){
            this.setState(() => ({
                    error: true,
                })
            )
        }else{
            this.props.editCallback(title, description)
        }
    }

    render() {
        return (
            <Dialog
                open={true}
                onClose={() => this.props.closeModal()}
                color={process.env.REACT_APP_BACKGROUND_COLOR}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle>
                   <Trans id="etdm-edit-title">Modifica titolo o sinossi</Trans>
                </DialogTitle>
                <form>
                    <DialogContent>
                        <Grid container columnSpacing={3} mb={2}>

                            <Grid item xs={4} >
                                <ZPlayFormField
                                    name={`edit-modal-language`}
                                    label={t({
                                        id: "etdm-title-language",
                                        message: "Lingua"
                                    })}
                                    formState={this.props.formState}
                                    control={this.props.control}
                                    trigger={this.props.trigger}
                                    disabled={true}
                                    />
                            </Grid>

                            <Grid item xs={8}>
                                <ZPlayFormField
                                    label={t({
                                        id: "etdm-title",
                                        message: "Titolo"
                                    })}
                                    name={`edit-modal-title`}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <ZPlayMultilineTextField
                                    label={t({
                                        id: "etdm-synopsis",
                                        message: "Sinossi"
                                    })}
                                    name={`edit-modal-description`}
                                    rows={2}
                                    maxLength={2048}
                                    control={this.props.control}
                                    formState={this.props.formState}
                                    trigger={this.props.trigger}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button size="small" onClick={this.props.closeModal}>
                            <Trans id={"etdm-close-btn"}>
                                Annulla
                            </Trans>
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            type="button"
                            disabled={this.props.formState.isSubmitting}
                            onClick={this.getValues}
                        >
                            <Trans id={"etdm-edit-btn"}>Modifica</Trans>
                        </Button>
                    </DialogActions>
                </form>
                {this.state.error && <Stack direction="row" spacing={1} mb={2}>
                    <ErrorIcon fontSize="small" color="error" />
                    <Typography
                        variant={"body2"}
                        color="error">
                        <Trans id={"etdm-title-synopsis-section-error"}>È necessario inserire il titolo e la sinossi per poter aggiungere una traduzione.</Trans>
                    </Typography>
                </Stack>}
            </Dialog>

        );
    }
}

export default withUseFormHook<{}>(EditTitleAndDescriptionModal, EditTitleAndDescriptionModalSchema, {});